export const de = {
  extraTitle: "Weitere Gründe für Sweet Trading",
  extraText: "Wir sind ein Team mit Leidenschaft für Technologie und Finanzmärkte. Wir arbeiten täglich daran, dir zuverlässige, hochwertige Tools bereitzustellen, die dem Markt immer einen Schritt voraus sind.",
  heroTitle: "EINE NEUE TRADING-GENERATION",
  heroSubtitle: "Statistiken zeigen, dass 98 % der Trader scheitern – aber nicht heute, und nicht mehr. Wir sind endlich hier, um diese Statistik für immer zu ändern. Sei jetzt Teil der Revolution!",
  buttonText: "Candy Bot entdecken",
  buttonLink: "#promo-section",
  whyTitle: "Warum Candy Bot?",
  whyText: "Automatisierung, Intelligenz, Geschwindigkeit. Mit einem Design, das Lust auf tägliches Trading macht.",
  disclaimer: "Alle auf dieser Website bereitgestellten Informationen dienen ausschließlich zu Bildungszwecken im Zusammenhang mit dem Handel an Finanzmärkten und stellen keine spezifische Investitionsempfehlung, Geschäftsempfehlung, Analyse von Investitionsmöglichkeiten oder andere allgemeine Empfehlung zum Handel mit Finanzinstrumenten dar. Die Informationen auf dieser Website richten sich nicht an Einwohner von Ländern oder Gerichtsbarkeiten, in denen eine solche Verbreitung oder Nutzung gegen lokale Gesetze oder Vorschriften verstoßen würde.",

 clockSection: {
  title1: "Jeder Tick",
  title2: "Zählt",
  line1: "Jede Sekunde, 24 Stunden am Tag, 5 Tage die Woche analysiert unser Bot die Märkte",
  line2: " um die besten Handelsmöglichkeiten zu identifizieren."
},


  processSection: {
    title: "Der Prozess in 3 Schritten",
    subtitle: "Von der Anmeldung bis zur Auszahlung – einfach und transparent",
    steps: [
      {
        number: "1",
        title: "Wähle deinen Plan",
        description: "Wähle den Plan, der am besten zu deinen Bedürfnissen passt, und schließe den Kauf mit nur wenigen Klicks ab.",
        timeLabel: "2 Minuten"
      },
      {
        number: "2",
        title: "Aktiv handeln",
        description: "Starte mit dem Trading gemäß den Anweisungen deines gewählten Plans. Unser System begleitet dich Schritt für Schritt.",
        timeLabel: "Variabel"
      },
      {
        number: "3",
        title: "Gewinne abheben",
        description: "Erhalte deine Gewinne innerhalb von 24–48 Stunden direkt auf dein Bankkonto oder Wallet.",
        timeLabel: "24–48 Stunden"
      }
    ]
  },

  whySection: {
    title: "Süß & Leistungsstark",
    description: "Gibt es etwas Süßeres als Geld? Ja! Leicht verdientes Geld. Leider existiert leicht verdientes Geld nicht – aber Candy Bot ist da, um dir das Leben zu versüßen und die harte Arbeit für dich zu übernehmen.",
    features: [
      {
        title: "KI-Power",
        highlight: "Künstliche Intelligenz",
        description: "Candy Bot nutzt modernste KI mit proprietären neuronalen Netzwerken zur Echtzeitanalyse globaler Märkte. Unser System kombiniert Deep Learning, Mustererkennung und prädiktive Analysen zur dynamischen Anpassung an volatile Marktbedingungen.",
        image: "/ai.jpg",
        icon: "FaRobot"
      },
      {
        title: "Konstante Performance",
        highlight: "Außergewöhnliche Ergebnisse",
        description: "Optimiert, um Fehler zu minimieren und Gewinne zu maximieren. Unsere adaptiven Algorithmen verfeinern kontinuierlich die Handelsstrategien und setzen robuste Risikomanagementprotokolle um.",
        image: "/performance.jpg",
        icon: "FaChartLine"
      },
      {
        title: "Forex-Optimiert",
        highlight: "Blitzschnelle Ausführung",
        description: "Reagiert in Millisekunden bei erkannten Mustern. Entwickelt für Hochfrequenzhandel, führt unser System Trades mit präzisem Timing aus und nutzt flüchtige Marktchancen optimal.",
        image: "/forex.jpg",
        icon: "FaBolt"
      }
    ]
  },

  tryBot: "Candy Bot kostenlos testen",
  sweetPower: "Süß und leistungsstark",
  sweetText: "Was ist süßer als Geld? Einfaches Geld. Leider gibt es das nicht – aber Candy Bot versüßt dir das Ganze und übernimmt die harte Arbeit.",
  aiTitle: "KI Power",
  aiSubtitle: "Künstliche Intelligenz",
  aiText: "Candy Bot nutzt fortschrittliche KI zur Echtzeitanalyse der Märkte. Dank neuronaler Engine kombiniert er Mustererkennung, Clustering und Prognosestrategien für dynamische Marktanpassung.",
  learnMore: "Mehr erfahren →",
  performanceTitle: "Konstante Performance",
  performanceSubtitle: "Außergewöhnliche Leistung",
  performanceText: "Optimiert, um Fehler zu minimieren und Gewinne zu maximieren. Unser System passt seine Strategien kontinuierlich an.",
  forexTitle: "Forex-optimiert",
  forexSubtitle: "Ultimative Geschwindigkeit",
  forexText: "Reagiert in Millisekunden bei erkannten Mustern. Perfektes Timing für jeden Trade.",

  numbersTitle: "In Zahlen",
  numbersSubtitle: "Unsere Community wächst täglich. Werde Teil tausender zufriedener Trader.",
  stats: [
    { value: "26+", label: "Monate mit Gewinn", desc: "Stetiges Wachstum seit dem Start" },
    { value: "7.000+", label: "Community-Mitglieder", desc: "Werde Teil unserer Familie" },
    { value: "19.529", label: "Erfolgreiche Trades", desc: "Mit Gewinn ausgeführt" },
    { value: "89,7%", label: "Erfolgsrate", desc: "Gesamtperformance" }
  ],

  offerTitle: "Sonderangebot",
  offerSubtitle: "Candy Bot Pro",
  offerText: "Die smarte Trading-Lösung, die für dich arbeitet",

  plans: [
    {
      name: "Candy Bot",
      desc: "Für deinen Einstieg",
      price: "0€",
      originalPrice: "169€",
      period: "für die ersten 24 Stunden",
      features: [
        "Voller Bot-Zugang",
        "24/7 Support",
        "Erweitertes Dashboard",
        "KI-Prognoseanalyse"
      ],
      cta: "Kostenlose Testversion starten",
      isNew: true
    }
  ],

  promo: {
    badge: "Sonderangebot",
    title: "Candy Bot",
    subtitle: "Zur Feier des Starts unseres neuen Bots und zur stolzen Markierung dieses Meilensteins bieten wir ihn zu einem unschlagbaren Preis an, <strong>nur für kurze Zeit verfügbar</strong>.",
    cardTitle: "Candy Bot Standard",
    cardSubtitle: "Starte noch heute deine Reise",
    newBadge: "NEU",
    oldPrice: "99€",
    newPrice: "0€",
    limitedNote: "Zeitlich begrenztes Angebot",
    features: [
      "Voller Bot-Zugang",
      "24/7 Support",
      "Erweitertes Dashboard",
      "KI-gestützte Analysen"
    ],
    button: "Candy Bot entdecken",
    promoTitle: "Limitierte Sonderaktion",
    promoText: "Melde dich <strong>jetzt</strong> an und erhalte vollen Zugang – ohne Zahlung, ohne Verpflichtung.",
    endsSoon: "Angebot endet bald!",
    benefits: [
      "✅ Keine Kosten",
      "✅ Jederzeit kündbar",
      "✅ Sofortige Aktivierung",
      "✅ Kostenlose Updates"
    ],
    guarantee: "🔒 14 Tage Geld-zurück-Garantie"
  },

  promoTitle: "Limitierte Aktion",
  promoText: "Zur Feier des Launchs von Candy Bot Pro bieten wir allen neuen Nutzern kostenlosen Zugang für 24 Stunden – bis zum 6. Mai.",
  promoItems: [
    "✅ Keine Kosten, keine Investition",
    "✅ Keine Verpflichtung",
    "✅ Persönlicher Support",
    "✅ Kostenlose Updates"
  ],
  promoGuarantee: "14-Tage-Zufriedenheitsgarantie",

  compareTitle: "Pläne vergleichen",
  compareSubtitle: "Von traditionell bis KI – finde die perfekte Lösung für dich",

  compareSection: {
    planTitle: "Candy Bot Standard",
    planSubtitle: "Alles, was du für den Start brauchst",
    priceFree: "0€",
    priceOld: "99€",
    offerNote: "Zeitlich begrenztes Angebot",
    features: [
      
      "7 Forex-Paare",
      "24/7 Support",
      "Schritt-für-Schritt-Anleitung",
      "70% Gewinnbeteiligung",
      "Mindestinvestition 100$"
    ],
    button: "Jetzt kostenlos sichern",
    popupTitle: "Du bekommst Candy Bot Standard",
    popupSubtitle: "Gib deine Daten ein, um das kostenlose Angebot zu beanspruchen",
    form: {
      name: "Vollständiger Name",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      submit: "Registrieren & Zugang erhalten"
    },
    disclaimer: "Mit dem Klick auf \"Registrieren\" akzeptierst du unsere",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutzrichtlinie"
  },
  comingSoonSection: {
  badge: "BALD VERFÜGBAR",
  title: "Candy Bot Pro",
  subtitle: "KI-Trading der nächsten Generation",
  priceLabel: "Demnächst verfügbar",
  priceDescription: "Demnächst verfügbar",
  features: [
    "KI-Modell für Aktien/Forex/Krypto",
    "3 verschiedene Märkte",
    "Priorisierter 24/7 Support",
    "Schritt-für-Schritt-Einrichtungsanleitung",
    "70% Gewinnbeteiligung",
    "Mindestinvestition 500$"
  ],
  buttonText: "Bald verfügbar"
},
 faq: {
  title: "Häufig gestellte Fragen",
  description: "Alle Antworten auf die häufigsten Fragen zu unserem Service",
  items: [
    {
      question: "Wie beginne ich mit der Nutzung von Candy Bot?",
      answer: "Klicken Sie einfach auf 'Kostenlose Testversion starten' und folgen Sie dem Registrierungsprozess."
    },
    {
      question: "Was ist, wenn ich keine Ahnung vom Trading habe?",
      answer: "Keine Sorge: Candy Bot wurde speziell für diejenigen entwickelt, die sich dem Trading ohne die üblichen Risiken nähern möchten – oder einfach für alle, die auf einfache und sichere Weise ein zusätzliches monatliches Einkommen erzielen wollen."
    },
    {
      question: "Wie hoch ist die durchschnittliche monatliche Rendite?",
      answer: "Die Renditen variieren je nach Marktbedingungen und gewähltem Plan, aber mit dem richtigen Kapital und dem passenden Bot ist es möglich, ein vollständiges monatliches Einkommen zu erzielen."
    },
    {
      question: "Für wen sind diese Bots gedacht?",
      answer: "Ideal für alle über 18, die risikofrei traden oder mühelos ihr monatliches Einkommen steigern möchten."
    },
    {
      question: "Kann ich mehrere Bots gleichzeitig laufen lassen?",
      answer: "Ja! Sie können mehrere Bots aktivieren, aber jeder muss auf einem separaten Konto betrieben werden, um Konflikte zu vermeiden."
    },
    {
  question: "Was ist der Forex-Markt?",
  answer: "Der Forex-Markt ist der Ort, an dem Währungen wie Euro und Dollar gehandelt werden. Er ist der größte der Welt, rund um die Uhr geöffnet und ermöglicht es, durch Schwankungen der Wechselkurse Gewinne zu erzielen."
}

  ]
},


  comparisonPlans: [
    {
      name: "Gen I Bots",
      desc: "Traditionelles Trading",
      price: "89€",
      originalPrice: "99€",
      discount: "-10%",
      features: [
        "Weniger Trades",
        "Basis-Marktanalyse",
        "E-Mail-Support",
        "3 Forex-Paare"
      ],
      cta: "Jetzt kaufen",
      type: "Einmalig (10 % Rabatt)"
    },
    {
      name: "Candy Bot Pro",
      desc: "Zweite KI-Generation",
      price: "0€",
      originalPrice: "169€",
      type: "Kostenlos für begrenzte Zeit",
      features: [
        "Unbegrenzte Trades",
        "KI-Prognoseanalyse",
        "12 Forex-Paare",
        "Priorisierter 24/7 Support",
        "Erweitertes Dashboard"
      ],
      cta: "Jetzt kostenlos",
      isOffer: true
    },
    {
      name: "Enterprise",
      desc: "Individuelle Lösung",
      price: "Individuell",
      type: "Preis auf Anfrage",
      features: [
        "Individuelle Konfiguration",
        "Dedizierte API-Integration",
        "Technischer Support 24/7",
        "Benutzerdefinierte KI-Modelle",
        "White-Label-Lösung",
        "Personalisierte Schulung"
      ],
      cta: "Demnächst verfügbar",
      isComing: true
    }
  ],

  faqTitle: "Häufige Fragen",
  faqSubtitle: "Antworten auf die häufigsten Fragen zu unserem Service",
  faqItems: [
    { question: "Wie starte ich mit Candy Bot?", answer: "Einfach auf 'Kostenlose Testversion starten' klicken und der Registrierung folgen." },
    { question: "Was, wenn ich keine Trading-Erfahrung habe?", answer: "Candy Bot ist für alle Erfahrungsstufen geeignet. Anfänger nutzen automatische Modi, Profis können Strategien anpassen." },
    { question: "Wie hoch ist die durchschnittliche Monatsrendite?", answer: "Historische Daten zeigen eine durchschnittliche Monatsrendite von 7–12 %. Vergangene Leistungen garantieren jedoch keine zukünftigen Ergebnisse." },
    { question: "Für wen sind die Bots geeignet?", answer: "Ideal für vielbeschäftigte Profis, Einsteiger und alle, die Trading automatisieren möchten." },
    { question: "Kann ich mehrere Bots gleichzeitig nutzen?", answer: "Ja! Du kannst mehrere Bots mit unterschiedlichen Strategien gleichzeitig laufen lassen." }
  ],

  legalTitle: "Rechtliches & Support",
  legalLinks: ["Nutzungsbedingungen", "Datenschutz"],
  supportEmail: "support@therealworld.net",
  supportChat: "Antwort innerhalb weniger Minuten",

  copyright: "© 2024–2025 Sweet Trading Inc. Alle Rechte vorbehalten. 🍬",

  features: [
    { title: "Intelligente KI", desc: "Analysiert und lernt in Echtzeit aus den Märkten." },
    { title: "Konstante Performance", desc: "Minimiert Fehler, maximiert Ertrag." },
    { title: "Blitzschnell", desc: "Reagiert in Millisekunden auf Marktsignale." },
    { title: "Aktive Community", desc: "Kontinuierliche Unterstützung & Austausch." }
  ],

  sectionTitles: {
    process: "3-Schritte-Prozess",
    features: "Hauptfunktionen",
    numbers: "In Zahlen",
    offer: "Sonderangebot",
    compare: "Pläne vergleichen",
    faq: "FAQ",
    support: "Support",
    bots: "Bots"
  },

  planDetails: {
    freeTrial: "24h KOSTENLOSE Testversion",
    includes: "Enthält:",
    mostPopular: "AM BELIEBTESTEN",
    bestValue: "BESTES PREIS-LEISTUNGS-VERHÄLTNIS"
  },

  ctaSection: {
    title: "Bereit, dein Trading zu verändern?",
    subtitle: "Schließe dich heute Tausenden zufriedener Trader an",
    button: "Jetzt kostenlos starten"
  },

  buttons: {
    backToTop: "Nach oben",
    contactSupport: "Support kontaktieren",
    downloadApp: "App herunterladen",
    login: "Login"
  },

  legal: {
    riskWarning: "RISIKOHINWEIS: Trading ist mit hohen Risiken verbunden und nicht für alle Anleger geeignet.",
    performanceDisclaimer: "Frühere Ergebnisse sind keine Garantie für zukünftige Erträge."
  },

  languages: {
    english: "Englisch",
    italian: "Italienisch",
    german: "Deutsch"
  }
};
